(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("portal-lambda-sdk", [], factory);
	else if(typeof exports === 'object')
		exports["portal-lambda-sdk"] = factory();
	else
		root["portal-lambda-sdk"] = factory();
})(global, () => {
return 